import {ReactElement, useState} from "react"
import {Button, Form, Input} from "antd"
import {useStore} from "@ui/stores"
import {TCaptainData} from "@ui/api/user"
import {t} from "@ui/common/intl"
import Loader from "@ui/components/common/Loader"
import SuccessModal from "./common/modal/Success"
import ErrorModal from "./common/modal/Error"
import Panel from "./common/Panel"
import {isInfoEqual, ProfilePage, TProfilePageProps} from "./common"

const Captain = ({setPage, close, isShow}: TProfilePageProps): ReactElement => {
  const {profile: {info: {name}, updateCaptain}} = useStore()
  const [changed, setChanged] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const handleFinish = async (data: TCaptainData) => {
    setLoading(true)
    updateCaptain(data)
      .then(() => setSuccess(true))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }

  const handleValueChanges = (changedValues: any, allValues: TCaptainData) => {
    setChanged(!isInfoEqual({name}, allValues))
  }

  return isShow ? (
    <Panel
      className="captain-form"
      title={t("profile.change.name.header")}
      onBack={() => setPage(ProfilePage.Main)}
      onClose={close}
    >
      {loading
        ? <Loader/>
        : <Form
            form={form}
            initialValues={{name}}
            onFinish={handleFinish}
            onValuesChange={handleValueChanges}
          >
            <Form.Item<TCaptainData> label={t("profile.captain.name.title")} name="name">
              <Input allowClear placeholder={t("profile.captain.name.placeholder")} maxLength={50} />
            </Form.Item>
            <Form.Item label={null} className="button-form-item">
              <Button type="primary" htmlType="submit" disabled={!changed}>
                {t("button.save")}
              </Button>
            </Form.Item>
          </Form>
      }
      <ErrorModal onClose={() => setError(false)} show={error} />
      <SuccessModal
        onClose={() => {
          setSuccess(false)
          setPage(ProfilePage.Main)
        }}
        title={t("profile.captain.update.success.title")}
        show={success}
      />
    </Panel>
  ) : (<></>)
}

export default Captain
